import { apiClient, Auth } from '@/shared/api'

import { TRefundAccount } from '../model/schema'

export const getGuestRefundAccount = async (contractId: number) => {
  const { data } = await apiClient.get<TRefundAccount>({
    endpoint: `/guest/contracts/${contractId}/refund-account`,
    auth: Auth.REQUIRED,
  })

  return data
}
